import { motion } from 'framer-motion';
import React from 'react';

type MotionDivProps = {
  children: React.ReactNode;
  key?: string | number;
  duration?: number; // Optional duration property
};

const MotionDiv: React.FC<MotionDivProps> = ({
                                               children,
                                               key,
                                               duration = 0.3 // Default value if duration is not provided
                                             }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    style={{ width: '100%' }}
    transition={{
      default: {
        type: 'tween',
        duration,
        ease: 'easeInOut',
      },
    }}
    key={key}
  >
    {children}
  </motion.div>
);

export default MotionDiv;
